import { Utilities as U } from '../utilities/utilities.model';

/*
 *   Questa classe serve per rappresentare l'entità Modulo,
 *   per ora l'esigenza urgente è per evitare dipendenza circolare per l'uso di NemoModuleKeys
 *  
 */

export class ModuleModel {

  id : string = '';
  key: NemoModuleKeys;

	constructor(model?: any) {
		
    if (U.isEmpty(model)) {
      return;
		}

		this.id = model.id;
    this.key = model.key;
	}
}  

// Purtroppo ho dovuto duplicaro - per evitare dipendenza circolare
// è utilizzato anche in user-permission.model.ts
export enum NemoModuleKeys {
	AUTHORITY           = 'authority',
	CLAIMS              = 'claims',
	CONTRACT_CLOSING    = 'contract_closing',
	CONTRACT_CLOSING_   = 'contract-closing',
	TYRES               = 'tyres',
	USER_CHNAGE         = 'user_change',
	USER_CHNAGE_        = 'change-user',
	LOGISTICS           = 'logistics',
	FLOTTA_POOL         = 'flotta-pool',
	INVOICING           = 'invoicing',
	DELIVERY            = 'delivery',
	BOOKINGS            = 'bookings',
	BOOKINGS_RELIEF     = 'bookings-relief',
	BOOKINGS_PRELEASE   = 'bookings-prelease',
	NOTIFICATION_CENTER = 'notification-center',
	ADMINISTRATION      = 'administration',
	MOBILITY            = 'mobility',
	CARGOS              = 'cargos'
	// TODO add all the other modules keys
}